var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18156",
    "data-name": "Group 18156",
    transform: "translate(-199 -525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18151",
    "data-name": "Group 18151",
    transform: "translate(202.187 529.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16486",
    "data-name": "Path 16486",
    d: "M31.269,23H10.545a.547.547,0,0,0-.545.545V37.179a.547.547,0,0,0,.545.545H31.269a.547.547,0,0,0,.545-.545V23.545A.547.547,0,0,0,31.269,23ZM29.96,24.091l-9.053,9.053-9.053-9.053Zm-18.869.763L16.6,30.362,11.091,35.87Zm.791,11.78,5.481-5.481,3.163,3.163a.527.527,0,0,0,.763,0l3.163-3.163,5.481,5.481Zm18.842-.764-5.508-5.508,5.508-5.508Z",
    transform: "translate(-10 -23)",
    fill: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8935",
    "data-name": "Rectangle 8935",
    width: 28,
    height: 26,
    transform: "translate(199 525)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.04fa09934dcf5271fc4da1b600bd6f6d.svg";
export { ForwardRef as ReactComponent };